import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { FormGroup, H2, H4, H6, HTMLSelect } from '@blueprintjs/core';
import { TablePagination, Paper } from '@material-ui/core';
import  Chart from 'react-apexcharts';
import MaterialTable from 'material-table';
import { estimatedClass } from '../common';
import { rounded }  from '../../../utils.js';
import Cookies from 'js-cookie';
import { FRONT_USER_LANG_COOKIE_NAME } from '../../../auth/constants.js';

//import { PUBLIC_URL, ANALYTICS_URL } from '../../../constants';

import './Chrono.css';


class ChronoOccs extends React.PureComponent {

  state = {
    displayType: "freq", // 'specByTimeId'
    height:300,
  }

  onTypeChange = (e) => {
    e.preventDefault();
    this.setState({ displayType: e.target.value });
  }

  initChart=()=> {
    this.setState({ height: 350 });
  }

  render() {
    const { warningIncompleteExtraction, t } = this.props;
    const langFormat = Cookies.get(FRONT_USER_LANG_COOKIE_NAME)==="en"? "en-EN":"fr-FR";

    const data=this.props.data.occs;
    const labels={
      'freq':t('frequency'),
      'relFreq':t('relFrequency'),
      'cumu':t('cumFrequency'),
      'spec':t('specificity'),
      'timeSpec':t('timeSpecificity'),
      'size':t('timeSpanSize'),
    };

    
    const type = this.state.displayType ;
    const typeLabel=labels[type];
    const typeLabelLower = typeLabel.toLowerCase();

    const disp = data.length;
    // data was previously a table of 6-uplets  [num,timeId,freqInTimeId,FreqGlobal,sizeOfTimeId,SizeGlobal]
    // then transformated into object {timeId,freq,spec}

    // constructing table element
    const table = (
      <MaterialTable
        columns={[
          { title: t('timeId'), field: 'timeId' },
          { title: typeLabel, field: type, render: rowData => <span className={estimatedClass(rowData[type],warningIncompleteExtraction)}>{rounded(rowData[type])}</span> },
        ]}
        data={data}
        title={typeLabel}
        options={{
          filtering: true,
          search: true,
          sorting: true,
          exportButton: true,
          exportFileName:typeLabelLower,
          exportAllData: true,
        }}
        components={{
          Pagination: props => (
            <TablePagination
              {...props}
              rowsPerPageOptions={[5, 10, 25, 50, 100, data.length]}
            />
          ),
          Container: props => (
            <Paper
              {...props}
              elevation={0}
            />
          ),
        }}
      />
    );

    const xyTab=[];
    if (data && data[0]) {
      // time format computation
      const k=data[0].timeId.split("-")[0].split("/");
      var dateFormat=(k===3)? "yyyy MMM dd" : (k===2) ? "yyyy MMM" : "yyyy";
      for (var i=0;i<data.length;i++) {
        const point=data[i];
        const timeId=point.timeId.split("-")[0];
        const ymd=timeId.split("/");
        const year=ymd[0];
        const month=ymd[1]?ymd[1]:1;
        const day=ymd[2]?ymd[2]:1;
        const val= point[type];
        xyTab.push(
          { x: new Date(year,month,day).getTime(),
            y: val
          }
        );
      }
    }
      
    // prep data for the chart
    const series = [{
        name:t(typeLabel),
        data: xyTab
    }];
    const options = {
        chart: {
          type: 'line',
          //height: 350
        },
        dataLabels: {
            enabled: false,
        },
        tooltip: {
          enabled:true,
          x: {
            show: true,
            format: dateFormat,
            formatter: undefined,
          },
        },
        yaxis: {
            title: {
                text: t(typeLabel),
            },
            labels: {
                formatter: function (y) {
                  return rounded(y,2);
                }
            }
        },
        xaxis: {
            type: 'datetime',
            //categories: xTab,
            labels: {
                rotate: -90,
                //datetimeFormatter: {
                  //year: 'yyyy',
                  //month: "MMM 'yy",
                  //day: 'dd MMM',
                  //hour: 'HH:mm',
                //},
            },
            
        }
    };
    
      
    return(
    <>

      <Paper className="margin-bottom-1-5-rem padding-1-rem">
        <H2>{t('searchResults')}</H2>

        <div className="margin-bottom-1-rem">
          <H4><u>{t('nbTimeSpan')}</u></H4>
          <ul>
             <li>{t('beginningColon')} {data[0].timeId}</li>
             <li>{t('endingColon')} {data[data.length-1].timeId}</li>
             <li>{t('dispColon')} {Intl.NumberFormat(langFormat).format(disp)}</li>
          </ul>
          
        </div>

        <div className="margin-bottom-1-5-rem">
          <H4><u>{t('detailedStats')}</u></H4>
          <FormGroup label={t('type')} labelFor='type' inline={true}>
          <HTMLSelect id='type' name='type' onClick={this.initChart} onChange={this.onTypeChange}>
              <option value='freq'>{t('freqByTimeId')}</option>
              <option value='relFreq'>{t('relFrequency')}</option>
              <option value='cumu'>{t('cumFreqByTimeId')}</option>
              <option value='spec'>{t('specByTimeId')}</option>
              <option value='timeSpec'>{t('timeSpecByTimeId')}</option>
              <option value='size'>{t('timeSpanSize')}</option>
            </HTMLSelect>
          </FormGroup>
        </div>

        <div className="margin-bottom-1-rem">
          <H6><u>{t('evolutionGlobal')}</u></H6>
          <div onClick={this.initChart}>
            <Chart options={options} series={series} height={this.state.height}/> 
          </div>
        </div>

        <H6><u>{t('completeResList')}</u></H6>
          {table}
      </Paper>
    </>
    );
  }

}

ChronoOccs.propTypes = {
  data: PropTypes.object,
  warningIncompleteExtraction: PropTypes.bool,
};

export default withTranslation()(ChronoOccs);
